if (!customElements.get("m-localization-form")) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      const select = this.querySelector("[data-localization-select]");
      if (!select) return;

      select.addEventListener("change", (event) => {
        const value = event.target.value;
        const form = select.closest("[data-localization-form]");
        const input = form?.querySelector("input[data-localization-input]");

        if (!form || !input) return;

        input.setAttribute("value", value);

        if (input.name === "country_code" && (value === "SA" || value === "AE")) {
          const domainPart = window.location.hostname.toLowerCase().endsWith("tanatel.com.sa")
            ? "; domain=.tanatel.com.sa"
            : "";
          document.cookie = `tanatel_country_choice=${value}; path=/; max-age=31536000; SameSite=Lax${domainPart}`;
        }

        // Tanatel regional stores:
        // UAE lives on its own Shopify store/domain. If the same theme is used
        // on the UAE store, choosing Saudi Arabia returns to the Saudi store.
        if (input.name === "country_code" && value === "AE") {
          if (window.TanatelPageLoader) window.TanatelPageLoader.show();
          window.location.assign("https://ae.tanatel.com.sa/");
          return;
        }

        if (
          input.name === "country_code" &&
          value === "SA" &&
          window.location.hostname.toLowerCase() === "ae.tanatel.com.sa"
        ) {
          if (window.TanatelPageLoader) window.TanatelPageLoader.show();
          window.location.assign("https://tanatel.com.sa/");
          return;
        }

        if (input.name === "locale_code" && window.TanatelPageLoader) {
          window.TanatelPageLoader.show();

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => form.submit());
          });
          return;
        }

        form.submit();
      });
    }
  }

  customElements.define("m-localization-form", LocalizationForm);
}
